import React from "react";
import { icons } from "../../../Assets/Icons/icons";
import { useNavigate } from "react-router-dom";

const PropertyCard = ({ property }) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => {
        navigate(`/property-details/${property?.id}`);
        window.scrollTo({
          left: 200, // Horizontal position
          top: 0, // Vertical position
          behavior: "smooth", // Makes the scroll animated
        });
      }}
      className="space-y-3 flex-shrink-0 snap-center xl:w-[18.5rem] lg:w-[19rem] md:w-[21rem] w-full shadow-lg rounded-xl group"
    >
      <figure className="h-72 cursor-pointer w-full rounded-xl overflow-hidden">
        <img
          className="h-full group-hover:scale-105 transition-all duration-300 w-full object-center object-cover"
          src={property?.images[0]}
          alt="property"
        />
      </figure>
      <article className="space-y-2 md:p-5 p-2 text-center">
        <h1 className="capitalize md:text-2xl text-xl font-semibold hover:text-[#E4E95B] transition-colors duration-300 cursor-pointer text-primaryTextColor">
          {property?.propertyName}
        </h1>
        <h6 className="text-secondaryTextColor text-sm md:text-base flex items-center justify-center gap-1">
          <span className="md:text-2xl text-xl">{icons.locationIcon}</span> {property?.location}
        </h6>
      </article>
    </div>
  );
};

export default PropertyCard;
